module.exports = __webpack_public_path__ + "static/media/400018_01.647c94a2.png";